import React from "react";
import { GoogleApiWrapper } from "google-maps-react";
import { Config } from "../../data/config";
import { setConnection } from "../../store/actions/connection";
import { connect } from "react-redux";
import { getPostalCode } from "../../util";
import { Input } from 'semantic-ui-react';
class GooglePlaceAutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.autocomplete = null;
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const { setConnectionData, resetErrors } = this.props;

    if (e.target.value === "") {
      setConnectionData({
        postalCode: null,
        address: ""
      });
    } else {
      resetErrors('address');
    }
  }

  componentDidMount() {
    const { google, setConnectionData } = this.props;
    const options = {
      types: ["geocode"],
      componentRestrictions: {
        country: "ca"
      }
    };
    const autocomplete = new google.maps.places.Autocomplete(
      this.autocomplete.inputRef,
      options
    );
    autocomplete.setFields(['address_components', 'formatted_address', 'geometry', 'icon', 'name', 'place_id']);
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      setConnectionData({
        postalCode: getPostalCode(place),
        address: this.autocomplete.inputRef.value,
        placeId: place.place_id
      });
    });
  }

  render() {
    const { error } = this.props;
    return (
      <React.Fragment>
        <Input
          ref={ref => (this.autocomplete = ref)}
          onChange={this.onChange}
          {...error && {
            color: "red",
            icon: "exclamation triangle"
          }}
          {...this.props.inputprops}
          labelPosition="right"
          label={<div className="label__text">Address</div>}
        />
        {error && (
          <div className="error-text">{error}</div>
        )}
      </React.Fragment>
    );
  }
}

GooglePlaceAutoComplete = GoogleApiWrapper({ apiKey: Config.apiKey })(
  GooglePlaceAutoComplete
);

const mapDispatchToProps = dispatch => {
  return {
    setConnectionData: data => dispatch(setConnection(data))
  };
};

export default connect(
  null,
  mapDispatchToProps
)(GooglePlaceAutoComplete);



// WEBPACK FOOTER //
// ./src/components/google-place-autocomplete/GooglePlaceAutoComplete.js